// extracted by mini-css-extract-plugin
export default {"history":"style_history__2DT0w"};